const routes = [
  {
      path: "/account/upgrade",
      name: "upgrade_account",
      component:  () => import(/* webpackChunkName: "UpgradeAccount" */ "./views/UpgradeAccount"),
      children: [
        {
          path: "*",
          redirect: { name: "upgrade_account"}
        }
      ]
  }
];

export default routes;
